import { useEffect } from 'react';

import { DEFAULT_THRESHOLD } from '../constants/settings';

export type UseScroll = {
  isEnabled: boolean;
  scrolledCallback: () => void;
  thresholdScreen?: number;
};

/**
 * Хук предназначен для отслеживания позиция скролла и при пересечении порога (threshold) вызывать scrolledCallback.
 */
export const useScroll = (props: UseScroll) => {
  const { isEnabled, scrolledCallback, thresholdScreen } = props;

  useEffect(() => {
    const handleScroll = () => {
      if (!isEnabled) {
        return;
      }

      const screenHeight = window.innerHeight;
      const scrollPosition = window.scrollY || window.pageYOffset;
      const threshold = screenHeight / (thresholdScreen || DEFAULT_THRESHOLD);

      if (scrollPosition > threshold) {
        if (typeof scrolledCallback === 'function') {
          scrolledCallback();
        }
        window.removeEventListener('scroll', handleScroll);
      }
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
